var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferaalPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 16.5V14.8333C13.3333 13.9493 12.9821 13.1014 12.357 12.4763C11.7319 11.8512 10.884 11.5 9.99998 11.5H4.16665C3.28259 11.5 2.43474 11.8512 1.80962 12.4763C1.1845 13.1014 0.833313 13.9493 0.833313 14.8333V16.5M16.6666 5.66667V10.6667M19.1666 8.16667H14.1666M10.4166 4.83333C10.4166 6.67428 8.92426 8.16667 7.08331 8.16667C5.24236 8.16667 3.74998 6.67428 3.74998 4.83333C3.74998 2.99238 5.24236 1.5 7.08331 1.5C8.92426 1.5 10.4166 2.99238 10.4166 4.83333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferaalPatient);
export default __webpack_public_path__ + "static/media/Referaal Patient.19d9e398788e8b250cea14b6ca1bd666.svg";
export { ForwardRef as ReactComponent };